import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import API from '../../api/index'
import {
  Table,
  Row,
  Col,
  Button,
  Tag,
  Icon
} from 'antd'
import Action from './Action'

class AreaList extends Component {
  constructor (props) {
    super(props)
    this.initialState = {
      areas: [],
      result: [],
      redirect: undefined,
      page: 1
    }
    this.handleCreateArea = this.handleCreateArea.bind(this)
    this.handleViewArea = this.handleViewArea.bind(this)
    this.handleUpdateArea = this.handleUpdateArea.bind(this)
    this.handlePrevArea = this.handlePrevArea.bind(this)
    this.handleNextArea = this.handleNextArea.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.state = this.initialState
    this.columns = [
      {
        title: 'Nombre',
        dataIndex: 'name',
        key: 'name'
      },
      {
        title: 'Activo',
        dataIndex: 'isActive',
        key: 'isActive',
        render: (text, record) => {
          return (
            <span>
              {record.isActive ? (
                <Icon type='check-circle' theme='twoTone' twoToneColor='#52c41a' />
              ) : (
                <Icon type='close-circle' theme='twoTone' twoToneColor='red' />
              )}
            </span>
          )
        }
      },
      {
        title: 'Acción',
        dataIndex: 'action',
        key: 'action',
        render: (text, record) => {
          return (
            <span>
              <Tag color='blue' onClick={() => this.handleViewArea(record._id)}>Ver detalle</Tag>
              <Tag color='orange' onClick={() => this.handleUpdateArea(record._id)}>Editar</Tag>
              <Action area={record} />
            </span>
          )
        }
      }
    ]
  }

  updateState (key, value) {
    this.setState({
      [key]: value
    })
  }

  async getPriorities (page) {
    const areas = await API.area.filter(page)
    this.updateState('areas', areas)
  }

  handleCreateArea () {
    this.updateState('redirect', '/area/create')
  }

  handleViewArea (id) {
    this.updateState('redirect', `/area/detail/${id}`)
  }

  handleUpdateArea (id) {
    this.updateState('redirect', `/area/update/${id}`)
  }

  handleChange (event) {
    this.updateState(event.target.name, event.target.value)
  }

  componentDidMount () {
    this.getPriorities(this.state.page)
  }

  handlePrevArea () {
    if (this.state.page > 1) {
      const page = this.state.page - 1
      this.updateState('page', page)
      this.getPriorities(page)
    }
  }

  handleNextArea () {
    if (this.state.areas.length >= 10) {
      const page = this.state.page + 1
      this.updateState('page', page)
      this.getPriorities(page)
    }
  }

  render () {
    if (this.state.redirect) {
      return (<Redirect to={this.state.redirect} />)
    }
    return (
      <div>
        <Row style={{ marginBottom: '20px' }}>
          <Col span={8}>
            <h3><strong>Listado de áreas</strong></h3>
          </Col>
          <Col offset={8} span={8} style={{ textAlign: 'right' }}>
            <Button onClick={this.handleCreateArea}>Crear área</Button>
          </Col>
        </Row>
        <Table
          columns={this.columns}
          dataSource={this.state.areas}
          size='small'
          pagination={{
            position: 'none'
          }}
          rowKey={record => record._id}
        />
        <div style={{
          textAlign: 'right',
          marginTop: '10px'
        }}>
          <ul className='ant-pagination '>
            <li className={this.state.page === 1 ? ('ant-pagination-disabled ant-pagination-prev') : ('ant-pagination-prev')}>
              <span onClick={this.handlePrevArea}>Anterior</span>
            </li>
            <li className='ant-pagination-item ant-pagination-item-1 ant-pagination-item-active'>{this.state.page}</li>
            <li className={this.state.areas.length >= 10 ? ('ant-pagination-next') : ('ant-pagination-disabled ant-pagination-next')}>
              <span onClick={this.handleNextArea}>Siguiente</span>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}

export default AreaList
